import React from "react";
import { ProgramData } from "@interfaces/Interfaces";
import LearningOutcomesCount from "./LearningOutcomesCount";
import * as ProgramUtils from "@utils/programUtils";
import { Icon_Add_Evidence } from "@assets/images";
import ProgramCardButton from "./ProgramCardButton";

type Props = {
  mandatoryCount: number;
  mandatoryTotal: number;
  mandatoryPercentage: number;
  mandatoryPartialCount?: number;
  mandatoryPartialPercentage?: number;
  optionalCount: number;
  optionalTotal: number;
  optionalPercentage: number;
  optionalPartialCount?: number;
  optionalPartialPercentage?: number;
  program: ProgramData;
  showEvidenceButton?: boolean;
  addProgramEvidence?: (params?: { type?: "skill" | "standard" | "capabilities" }) => void;
  userRoleName?: string;
};

const LearningOutcomesHeader: React.FC<Props> = (props) => {
  const role = props.userRoleName ? props.program.Roles?.find((role) => role.Name === props.userRoleName) : undefined;

  return (
    <div className="flex flex-col bg-white pl-safe-area-l pr-safe-area-r pt-4">
      <div className="leading-acc-lh text-acc-17px font-extrabold tracking-default text-grey-90">
        {props.program.LearningOutcomesName ?? "Learning Outcomes"}
      </div>
      <div className="whitespace-pre-line text-acc-13px font-acc-normal leading-default tracking-[-0.1px] text-grey-70">
        {ProgramUtils.getLearningObjectivesListHeaderText(props.program, props.userRoleName)}
      </div>
      <div className="leading-acc-lh mb-4 mt-3 text-acc-13px font-acc-normal tracking-[-0.1px] text-grey-70">
        {ProgramUtils.getLearningObjectivesCardTitle(props.program, props.userRoleName)}
      </div>
      {props.mandatoryTotal > 0 && (
        <LearningOutcomesCount
          count={props.mandatoryCount}
          total={props.mandatoryTotal}
          percentage={props.mandatoryPercentage}
          showExplanatoryText={role?.LOsCardExplanatoryText !== undefined}
          explanatoryText={role?.LOsCardExplanatoryText}
          partialCount={props.mandatoryPartialCount}
          partialPercentage={props.mandatoryPartialPercentage}
        />
      )}
      {props.optionalTotal > 0 && (
        <LearningOutcomesCount
          count={props.optionalCount}
          total={props.optionalTotal}
          percentage={props.optionalPercentage}
          showExplanatoryText={role?.LOsCardExplanatoryText !== undefined}
          explanatoryText={"of optional"}
          partialCount={props.optionalPartialCount}
          partialPercentage={props.optionalPartialPercentage}
        />
      )}
      {props.showEvidenceButton && (
        <ProgramCardButton
          buttonPressed={() => props.addProgramEvidence?.({ type: "capabilities" })}
          buttonText="Add new evidence"
          icon={Icon_Add_Evidence}
        />
      )}
    </div>
  );
};

export default LearningOutcomesHeader;
